import React from 'react'
import Link from 'gatsby-link'

import {format as formatDate} from 'date-fns'
import {renderIf} from '../../lib/util.js'

const getMeetingTime  = (course) => {
  if(course.meetingTime) return course.meetingTime
    switch(course.family){
      case '101':
        return course.dailySchedule
      case '102':
        if(course.track == 'day'){
          return 'Monday – Friday, 9 am – 6 pm'
        } 
        if(course.track == 'night') {
          return 'Monday - Thursday, 6:30 – 9:30 pm; Saturday, 9:00 am – 6:00 pm'
        } 
        if(course.track == 'self-paced') {
          return 'Self-Paced Online Course'
        }
      case '501':
        return ''
      case '502':
        return ''
      case 'aitoolsforcoders-501':
        if(course.track == 'day') {
          return 'Monday - Friday, Lecture: 12 – 1 pm; Lab (optional): 1 – 2 pm'
        }
        if(course.track == 'self-paced') {
          return 'Self-Paced Online Course'
        }
      case 'aitoolsforprofessionals-501':
        if(course.track == 'day') {
          return 'Monday - Friday, Lecture: 12 – 1 pm; Lab (optional): 1 – 2 pm'
        }
        if(course.track == 'self-paced') {
          return 'Self-Paced Online Course'
        }
    default:
        if(course.track == 'day'){
          return 'Monday – Friday, 9 am – 6 pm'
        }
        if(course.track == 'night') {
          return 'Monday – Thursday, 6:30 – 9:30 pm; Saturday, 9:00 am – 6:00 pm'
        } 
        if(course.track == 'self-paced') {
          return 'Self-Paced Online Course'
        }
    }
}

const familyToLearnMoreMap = {
    'code-101': '/courses/code-101/explore-software-development/',
    'ops-101': '/courses/ops-101/explore-cybersecurity/',
    'web3-101': '/courses/web3-101/explore-cryptocurrencies-and-web3-careers/',
    'code-102': '/courses/code-102/intro-to-software-development/',
    'ops-102': '/courses/ops-102/intro-to-computer-operations/',
    'code-201': '/courses/code-201/foundations-of-software-development/',
    'ops-201': '/courses/ops-201/foundations-of-computer-operations/',
    'code-301': '/courses/code-301/intermediate-software-development/',
    'ops-301': '/courses/ops-301/networking-and-systems-administration/',
    'code-501': '/courses/code-500/',
    'code-502': '/courses/code-500/',
    'code-java-401': '/courses/code-401/advanced-software-development-in-java-with-springmvc-and-android/',
    'code-python-401': '/courses/code-401/advanced-software-development-in-python/',
    'code-javascript-401': '/courses/code-401/advanced-software-development-in-full-stack-javascript/',
    'code-dotnet-401': '/courses/code-401/advanced-software-development-in-asp-net-core/',
    'ops-cybersecurity-401': '/courses/ops-401/cybersecurity-engineering/',
    'ai-aitoolsforcoders-501': '/courses/ai-501/ai-tools-for-coders/',
    'ai-aitoolsforprofessionals-501': '/courses/ai-501/ai-tools-for-professionals/'
}

export default ({key, course, designateLocation}) => {
  let actionButtonText = new Set(['101', '501', '502', 'aitoolsforcoders-501', 'aitoolsforprofessionals-501']).has(course.family) ? 'Sign Up' : 'Apply Now'
  return (
    <article itemScope itemType='http://schema.org/CourseInstance' className='calendar-event cf' key={key} id={course.urlHash}>
      <h2 className='course-date'>
        <span itemProp="startDate" content={course.startDate}>{formatDate(course.startDate, 'MMM D, YYYY')}</span>
        { (course.endDate && (course.endDate.toString() != 'Invalid Date') ? <span> - <span itemProp='endDate' content={course.endDate}>{formatDate(course.endDate, 'MMM D, YYYY')}</span></span>: '')}
      </h2>
      {renderIf(course.courseStatus, <h2>{course.courseStatus}</h2>)}
      <Link to={`/course-calendar#${course.urlHash}`}>
        <h1 itemProp='name' className='chain-link, width-80-percent' style={{color: '#000'}}>{course.title}</h1>
      </Link>
      <header>
        {/* renderIf(course.price, <h2>${course.price}</h2>) */}
        {course.track === 'self-paced' || designateLocation !== true ? <h2>{getMeetingTime(course)}</h2> : ''}
        {designateLocation === true ? course.onlineVsInPerson === 'In-Person' ? 
        renderIf(course.location, <h2 itemProp='location' className='width-80-percent'>
          { course.location.name + ', ' +
            course.location.streetAddress+ ', ' +
            course.location.city + ', ' +
            course.location.state + ' ' +
            course.location.zipCode
          }</h2>) 
          : 
          course.track !== 'self-paced' && (course.onlineVsInPerson === 'Online' || course.onlineVsInPerson === 'None') ? 
          <div>
            <h2 itemProp='location' className='width-80-percent'>Online Course</h2> 
            <h2 className='width-80-percent'>{getMeetingTime(course)}</h2>
          </div>
          : 
          course.track === 'self-paced' ? 
          ''
          :
          <div>
            <h2 itemProp='location' className='width-80-percent'>
              Online or In-Person Course
            </h2>
            <h2 itemProp='location' className='width-80-percent'>
              { course.location.name + ', ' +
              course.location.streetAddress+ ', ' +
              course.location.city + ', ' +
              course.location.state + ' ' +
              course.location.zipCode
              }
            </h2> 
          </div> : ''}
        {renderIf(course.scholarshipDeadline && course.family != '101' && course.family != '102' && course.family != '501' && course.family != '502' && course.family != 'aitoolsforcoders-501' && course.family != 'aitoolsforprofessionals-501',
          <h2 className='width-80-percent'>
            <a href='/financing-and-scholarships/'>Scholarship Application</a>
            {renderIf(course.scholarshipDeadline, ' By: ' + formatDate(course.scholarshipDeadline, 'MMM D, YYYY'))}
          </h2>
        )}
        {renderIf(course.signupUrl && course.family != '101' && course.family != '102' && course.family != '501' && course.family != '502' && course.family != 'aitoolsforcoders-501' && course.family != 'aitoolsforprofessionals-501',
          <h2 className='width-80-percent'>
            <a href={course.signupUrl}>Start Course Application</a>
            {renderIf(course.applicationDeadline, ' By: ' + formatDate(course.applicationDeadline, 'MMM D, YYYY'))}
          </h2>
        )}
        <h2 className='width-80-percent'>
          <Link to={familyToLearnMoreMap[course.sequenceAndFamily]}>Learn More »</Link>
        </h2>
        <div className='action-buttons cal-btn'>
          <a href={course.signupUrl} target='_blank'>{actionButtonText}</a>
        </div>
      </header>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/components/course-calendar-item/index.js